import dayjs from 'dayjs';
export default {
  name: 'LogTable',
  props: {
    logData: { type: Array, required: true },
    logStatus: { type: Object, required: true },
    logEinvoiceStatus: { type: Object, required: true }
  },
  methods: {
    onToggleRow(log) {
      this.$emit('toggle-row', log)
    },
    isObjectEmpty(obj) {
      if (!obj) return false
      if (typeof obj !== 'object') return false
      return Object.keys(obj).length === 0
    },
    activeObject(oldObj, newObj) {
      if (oldObj && !this.isObjectEmpty(oldObj)) return oldObj
      if (newObj && !this.isObjectEmpty(newObj)) return newObj
      return {}
    },
    getFieldLabel(key) {
     let k = typeof key === 'string' ? key.trim() : String(key).trim()

			// Bóc cặp dấu ngoặc ở đầu và cuối nếu có
			const k2 = /^".*"$/.test(k)
				? `'${k.slice(1, -1).replace(/'/g, "\\'")}'`
				: k
			var label = this.$t(k2)
			return label
    },
	formartValue(value,key) {
	var keyValue = key + "_" + value;
	var keyValueTrans = this.$t(keyValue);
	if(keyValueTrans != keyValue){
		value = keyValueTrans
	}
	 if( dayjs(value, "YYYY-MM-DDTHH:mm:ss", true).isValid())
      {
        value = dayjs(value).add(7, 'hour').format("DD/MM/YYYY HH:mm")
      }
    else if( dayjs(value, "YYYY-MM-DDTHH:mm:ssZ", true).isValid())
      {
        value = dayjs(value).format("DD/MM/YYYY HH:mm")
      }
	  return value
	},
    getActionLogStatusUI(statusId) {
      if (!this.logStatus) return {}
      let status
      switch (statusId) {
        case 1: status = this.logStatus.CHANGED; break
        case 2: status = this.logStatus.ADDED; break
        case 3: status = this.logStatus.DELETED; break
        default: status = null
      }
      if (!status) return {}
      return { ...status, text: this.$t(status.text) }
    },
    getActionEInvoiceStatusUI(statusId) {
      const s = this.logEinvoiceStatus
      if (!s) return ''
      let key = null
      switch (statusId) {
        case 1: key = s.ISSUE_INVOICE_WITHOUT_SIGNATURE; break
        case 2: key = s.CREATE_DRAFT_INVOICE; break
        case 3: key = s.EDIT_UNSIGNED_INVOICE; break
        case 4: key = s.DELETE_UNSIGNED_INVOICE; break
        //case 5: key = s.ISSUE_AND_SIGN_INVOICE; break
        case 6: key = s.REPLACE_SIGNED_INVOICE; break
        case 7: key = s.ADJUST_SIGNED_INVOICE; break
        // case 8: key = s.INCREASE_PRODUCT_PRICE_IN_SIGNED_INVOICE; break
        // case 9: key = s.DECREASE_PRODUCT_PRICE_IN_SIGNED_INVOICE; break
        // case 10: key = s.ADJUST_INFOR_INVOICE; break
        case 12: key = s.SIGN_INVOICE; break
        default: return ''
      }
      return key
    }
  }
}